import { jsx as _jsx } from "react/jsx-runtime";
import AdminLayout from '../components/admin/AdminLayout';
export default function AdminPanel() {
    return _jsx(AdminLayout, {});
}
//# sourceMappingURL=AdminPanel.js.map